import { pxToRem } from '../helpers/rem';
export const defaultBreakpoints = {
    xs: pxToRem(0),
    sm: pxToRem(600),
    md: pxToRem(900),
    lg: pxToRem(1200),
    xl: pxToRem(1608),
};
export const sizes = {
    spinner: {
        small: pxToRem(6),
        medium: pxToRem(12),
        large: pxToRem(24),
        borderWidth: pxToRem(4),
    },
    card: {
        boxShadowOffsetX: pxToRem(0),
        boxShadowOffsetY: pxToRem(1),
        boxShadowBlurRadius: pxToRem(7),
        borderRadius: pxToRem(12),
    },
    button: {
        borderRadius: pxToRem(4),
        largeHeight: pxToRem(44),
        smallHeight: pxToRem(36),
        underlineOffset: pxToRem(1),
    },
    splitButton: {
        menuToggleWidth: pxToRem(32),
    },
    icon: {
        medium: pxToRem(24),
        small: pxToRem(16),
    },
    input: {
        underlineWidth: pxToRem(1),
        borderRadius: pxToRem(4),
    },
    tag: {
        borderRadius: pxToRem(16),
    },
    radio: {
        size: pxToRem(20),
        borderWidth: pxToRem(1),
        donutSize: pxToRem(12),
    },
    checkbox: {
        size: pxToRem(20),
        borderWidth: pxToRem(1),
        borderRadius: pxToRem(4),
    },
    hint: {
        borderRadius: pxToRem(6),
    },
    divider: {
        thickness: pxToRem(1),
    },
    sidebar: {
        headerHeight: pxToRem(40),
        accountPadding: pxToRem(24),
        avatarSize: pxToRem(40),
    },
    horizontalNavigation: {
        thickness: pxToRem(4),
    },
    tooltip: {
        borderRadius: pxToRem(4),
        maxWidth: pxToRem(250),
    },
    floatingSurface: {
        boxShadowOffsetX: pxToRem(0),
        boxShadowOffsetY: pxToRem(5),
        boxShadowBlurRadius: pxToRem(7),
        borderRadius: pxToRem(4),
    },
    stepper: {
        icon: { size: pxToRem(20), marginBottom: pxToRem(4) },
        outerCircle: {
            size: pxToRem(18),
            borderWidth: pxToRem(1),
        },
        innerCircle: {
            size: pxToRem(12),
        },
        stepLine: {
            borderWidth: pxToRem(1),
        },
    },
    dialog: {
        overlayBlur: pxToRem(1),
        widthSm: pxToRem(400),
        widthMd: pxToRem(640),
        widthLg: pxToRem(1100),
    },
    toolbar: {
        topShadowBlur: pxToRem(7),
        bottomShadowBlur: pxToRem(30),
    },
    toggle: {
        width: pxToRem(40),
        height: pxToRem(22),
        thumbOutline: pxToRem(1),
    },
    editableTag: {
        borderWidth: pxToRem(1),
        borderRadius: pxToRem(4),
    },
    editableTagCreateInput: { height: pxToRem(21) },
    searchInput: { borderWidth: pxToRem(1) },
    navBarHorizontal: {
        borderRadius: pxToRem(6),
    },
    textArea: {
        minHeight: pxToRem(50),
    },
    dialogCenteredTextContainer: {
        horizontalSpacing: pxToRem(80),
    },
    table: {
        borderRadius: pxToRem(6),
        borderThickness: pxToRem(1),
    },
    dynamicTable: {
        headerBorderRadius: pxToRem(6),
        rowBorderThickness: pxToRem(1),
        pinnedColumnShadowOffsetX: pxToRem(12),
        pinnedColumnShadowOffsetY: pxToRem(0),
        pinnedColumnShadowBlurRadius: pxToRem(14),
        pinnedColumnShadowSpreadRadius: pxToRem(-10),
    },
    blurrableContainer: {
        blurFilter: pxToRem(1),
    },
    navigationVerticalItem: {
        boxShadowOffsetX: pxToRem(0),
        boxShadowOffsetY: pxToRem(1),
        boxShadowBlurRadius: pxToRem(7),
        borderRadius: pxToRem(6),
    },
    combobox: {
        maxHeight: pxToRem(320),
    },
    illustration: {
        small: pxToRem(30),
        medium: pxToRem(140),
        large: pxToRem(280),
    },
    animation: {
        small: pxToRem(60),
        medium: pxToRem(160),
    },
    dot: {
        small: {
            height: pxToRem(4),
            width: pxToRem(4),
        },
        medium: {
            height: pxToRem(6),
            width: pxToRem(6),
        },
        large: {
            height: pxToRem(8),
            width: pxToRem(8),
        },
    },
    calendar: {
        borderRadius: pxToRem(4),
        daysMinHeight: pxToRem(240),
        shortWeekDays: {
            textWidth: pxToRem(40),
            textHeight: pxToRem(40),
        },
        day: {
            dayWidth: pxToRem(40),
            dayHeight: pxToRem(40),
            borderRadius: pxToRem(8),
            borderWidth: pxToRem(2),
        },
    },
    phoneNumberInput: {
        phoneInputWidth: '100%',
        selectPrefixMinWidth: pxToRem(100),
        selectPrefixDropdownMinWidth: `min(${pxToRem(352)}, calc(100vw - ${pxToRem(32)}))`,
    },
    expansionTable: {
        expansionTableRow: {
            borderRadius: pxToRem(6),
        },
    },
    infoPanel: {
        borderRadius: pxToRem(6),
    },
    select: {
        maxHeight: pxToRem(400),
    },
    skeletonBlock: {
        defaultWidth: '100%',
        defaultHeight: pxToRem(16),
        defaultBorderRadius: pxToRem(4),
    },
};
